<template>
  <div class="row" v-if="can_access('customer','view')">
    <div class="col-md-12  form-group mb-0" style="display: block ruby;">
		    <h1 class="">Control Reports</h1>
        <div class="form-inline pull-right">
          <div class="form-group">
                <multiselect 
                ref="multiselect"
                style="margin-right:5px"
                v-model="account_numbers" 
                :options="customers"
                :multiple="true"
                open-direction="bottom"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="false"
                :searchable="false"
                placeholder="Pick some Accounts" 
                :preselect-first="false"
                @close="isOpen = false"
                @open="isOpen = true">
                  <template slot="clear">
                    <div class="multiselect__clear" v-if="account_numbers != null && account_numbers.length" @mousedown.prevent.stop="clearAll()"></div>
                  </template>
                  <template slot="selection" slot-scope="{ values }"><span class="multiselect__single" v-if="values.length">{{ values.filter(val => val == 'ALL').length?'All':values.length }} account(s) selected</span></template>
                </multiselect>
            </div>
            <div class="form-group">
                <b-form-select v-model="sheet" style="color:#000;font-weight:600;margin-right:5px" :options="options" class=""></b-form-select>
            </div>
            <div class="form-group">    
                <date-picker input-class="form-control" :disabled-date="disabledDates" ref="report_date" value-type="format" range type="date" v-model="report_date" format='DD-MM-YYYY'></date-picker>
            </div>
            <div class="form-group ml-2">    
              <b-button @click="getResult" class="btn-info pull-right mb-0" title="View Report" v-if="can_access('report','view')">View Report</b-button>
            </div>
        </div>
    </div>
    <div class="col-md-12 mb-3" v-if="ViewReports">
      
    </div>
    <div class="col-md-12" v-if="ViewReports">
      <b-button @click="generate_control_report" class="btn btn-lg btn-default pull-right mb-0" title="Generate Reports" v-if="can_access('report','download')">Generate All Reports</b-button>
      <!-- <b-button @click="generate_control_report('only')" class="btn-info pull-right mb-0" title="Generate Reports" v-if="can_access('report','download')">Generate Current Report</b-button> -->
      <!-- <b-button @click="get_report_modal" class="btn-info pull-right" title="Download Reports" v-if="can_access('report','download')">Download Report</b-button> -->
    </div>
    <div class="col-md-12" v-if="ViewReports">
      <h6 class="pull-right " style="font-size:0.700rem;">(*Generate Report From <span style="font-weight:500">{{report_date[0]}}</span> To <span style="font-weight:500">{{report_date[1]}}</span>)</h6>
    </div>
    <div class="col-md-12 mb-2" v-if="ViewReports">
      <a href="javascript:;" @click="get_report_modal" class="pull-right" title="Download Reports" v-if="can_access('report','download')">Download From Archives</a>
    </div>
    <div class="col-md-12" v-if="ViewReports">
      <TableView :col="columns" :getData="getData" v-if="can_access('customer','view') && !sheet"/>
      <MISDailyStatusReport :report_date="report_date" :account_numbers="account_numbers" v-else-if="sheet==1 && can_access('report','view')"/>
      <ReconciliationCashAnalysis :report_date="report_date" :account_numbers="account_numbers" :report="sheet" v-else-if="['2','3','4'].indexOf(sheet)>=0 && can_access('report','view')"/>
      <ReconciliationCashBalance :report_date="report_date" :report="sheet" v-else-if="['5','6','7'].indexOf(sheet)>=0 && can_access('report','view')"/>
      <StockHoldingAnalysis :report_date="report_date" :account_numbers="account_numbers" v-else-if="sheet==9 && can_access('report','view')"/>
      <EquityReport :report_date="report_date" v-else-if="sheet==10 && can_access('report','view')"/>
      <DealTicketsReport :report_date="report_date" @setFilter='setFilter' v-else-if="sheet==11 && can_access('report','view')"/>
      <SteelEyeReport :report_date="report_date" @setFilter='setFilter' v-else-if="sheet==12 && can_access('report','view')"/>
      <SecurityReconciliationAndValuationReport :report_date="report_date" :account_numbers="account_numbers" v-else-if="sheet==13 && can_access('report','view')"/>
    </div>

    <div class="col-md-12" v-if="ViewReports">
      <b-button @click="generate_control_report('only')" class="btn-info pull-right mb-0" title="Generate Reports" v-if="can_access('report','download')">Download This Report</b-button>
    </div>

    <b-modal ref="get-report-out" title="Download Reports" size="xl" hide-footer>
      <ReportsInExcel file_prefix="control_report"/>
    </b-modal>
    <b-modal ref="get_filename" :title="'Set Filename'" size="md" hide-footer @hidden="setFilename">
      <div class="form-group">
        <label>Filename</label>
        <b-input-group>
          <template v-slot:prepend>
            <b-input-group-text >{{filenameprefix}}</b-input-group-text>
          </template>
          <b-form-input ref="file_name" v-model="filename" placeholder="Enter filename here.."></b-form-input>
          <template v-slot:append>
            <b-form-select v-model="filetype" :options="filetype_options"></b-form-select>
          </template>
        </b-input-group>
        <button type="button" class="btn btn-lg btn-info pull-right mt-2" @click="generate_control_report">Generate</button>
      </div>

    </b-modal>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import common from '@/assets/js/common.js';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import AddCustomerForm from '@/components/Accounts/AddCustomerForm';
import TableView from '@/components/Common/DataTable/Table';
import MISDailyStatusReport from '@/components/Accounts/MISDailyStatusReport.vue';
import ReconciliationCashAnalysis from '@/components/Accounts/ReconciliationCashAnalysis.vue';
import ReconciliationCashBalance from '@/components/Accounts/ReconciliationCashBalance.vue';
import DatePicker from 'vue2-datepicker';
import ReportsInExcel from '@/components/Accounts/ReportsInExcel.vue';
import StockHoldingAnalysis from '@/components/Accounts/StockHoldingAnalysisReport.vue';
import EquityReport from '@/components/Accounts/EquityReport.vue';
import DealTicketsReport from '@/components/Accounts/DealTicketsReport.vue';
import SteelEyeReport from '@/components/Accounts/SteelEyeReport.vue';
import SecurityReconciliationAndValuationReport from '@/components/Accounts/SecurityReconciliationAndValuationReport.vue'

window.moment = moment();
export default {
  name: 'ControlReportsPage',
  components: { Widget, Multiselect, AddCustomerForm, DatePicker, TableView, MISDailyStatusReport, ReconciliationCashAnalysis, ReconciliationCashBalance,StockHoldingAnalysis,SecurityReconciliationAndValuationReport, ReportsInExcel,EquityReport, DealTicketsReport, SteelEyeReport},
  mixins: [common],
  data() {
    return {
      ViewReports : true,
      sheet: 1,
      isOpen: false,
      customers: ['ALL'],
      account_numbers: ['ALL'],
      filenameprefix: 'control_report-',
      filename: '',
      filetype: 'xlsx',
      filetype_options: [
          { value: 'xlsx', text: '.xlsx' },
          /* { value: 'pdf', text: '.pdf' }, */
        ],
      filter: {},
      report_date: [moment().startOf('month').format('DD-MM-YYYY'),moment().format('DD-MM-YYYY')],
      shortcuts: [
        {
          text: 'Today',
          onClick() {
            return moment();
          },
        },
        {
          text: 'Yesterday',
          onClick() {
            return [moment().subtract(1, 'days').format('DD-MM-YYYY'),moment().subtract(1, 'days').format('DD-MM-YYYY')];
          },
        },
        {
          text: 'This Month',
          onClick() {
            return [moment().startOf('month').format('DD-MM-YYYY'),moment().format('DD-MM-YYYY')];
          },
        },
        {
          text: 'Last Month',
          onClick() {
            return [moment().subtract(1, 'month').startOf('month').format('DD-MM-YYYY'),moment().subtract(1, 'month').endOf('month').format('DD-MM-YYYY')];
          },
        },
      ],
      options: [
        { value: '1', text: 'MIS DAILY STATUS' },
        { value: '2', text: 'RECONCILIATION CASH ANALYSIS' },
        { value: '3', text: 'RECONCILIATION LIVE CASH ANALYSIS' },
        { value: '4', text: 'RECONCILIATION SECURITY ANALYSIS' },
        { value: '5', text: 'RECONCILIATION CASH BALANCE' },
        { value: '6', text: 'RECONCILIATION LIVE CASH BALANCE' },
        { value: '7', text: 'RECONCILIATION SECURITY BALANCE' },
        { value: '9', text: 'STOCK HOLDING ANALYSIS' },
        { value: '13', text: 'SECURITIES RECONCILIATION AND VALUATION' },
        { value: '10', text: 'EQUITY REPORT' },
        { value: '11', text: 'DEAL ACTIVITY REPORT' },
        { value: '12', text: 'STEELEYE REPORT' },
      ],
      showAddCustomerForm: false,
      errorMessage: null,
      columns: (() => {
        const cols = [
          { title: 'Accoun No.', field: 'account_number', label: 'User ID', thComp: 'FilterTh', sortable: true, visible: 'true' },
          { title: 'Title', field: 'title', thComp: 'FilterTh' },
          { title: 'Firstname', field: 'firstname', thComp: 'FilterTh', tdStyle: { fontStyle: 'italic' } },
          { title: 'Lastname', field: 'lastname', thComp: 'FilterTh', thStyle: { fontWeight: 'normal' } },
          { title: 'Email', field: 'email', thComp: 'FilterTh', tdComp: 'Email'},
          { title: 'Phone', field: 'phone_no', thComp: 'FilterTh'},
          { title: 'DOB', field: 'dob', sortable: true },
          { title: 'Last Traded Date', field: 'last_trade_date', sortable: true, colClass: 'w-240', tdComp: 'CreatetimeTd' },
          { title: 'Operation', tdComp: 'reportOpt', visible: 'true', tdStyle:{'text-align':'center'}, thStyle:{'text-align':'center'} }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  watch:{
    /* "report_date": function(value){
      if(moment(this.report_date[1],'DD-MM-YYYY').diff(moment(this.report_date[0],'DD-MM-YYYY'), 'months') <= 1){
        this.ViewReports = false;
        this.$nextTick(function(){
          this.filename = '';
          this.ViewReports = true;
        });
      }else{
        this.$toasted.error("Reports can be viewed for a maximum of 1 monts!",{duration:2000});
      }
    },
    "sheet": function(){
      this.ViewReports = false;
      this.$nextTick(() => {
        this.ViewReports = true;
      });
    } */
  },
  methods: {
    customerFormReRender(response) {
      if(response.code==0){
        this.showAddCustomerForm = false;
        this.$nextTick(function(){
          this.showAddCustomerForm = true;
          this.$toasted.success("Successfully Added",{duration:1000});
        });
      }
    },
    async getCustomer() {
      let uri = 'customer_account_list';
      this.call_axios(uri).then(({response}) => {
        this.customers = this.customers.concat(response.data.result);
      });     
    },
    setFilter(filter){
      this.filter = filter;
    },
    getResult()
    {
      this.ViewReports = false;
      if(moment(this.report_date[0], 'DD-MM-YYYY').isSameOrBefore(moment()) && moment(this.report_date[1], 'DD-MM-YYYY').isSameOrBefore(moment())){
        if(moment(this.report_date[1],'DD-MM-YYYY').diff(moment(this.report_date[0],'DD-MM-YYYY'), 'months') <= 1){
          this.$nextTick(function(){
            this.filename = '';
            this.ViewReports = true;
          });
        }else{
          this.$toasted.error("Reports can be viewed for a maximum of 1 monts!",{duration:2000});
        }
      }else{
          this.$toasted.error("Date cannot be in the future.",{duration:2000});
        }
    },
    async getData(query, filter) {
      if(this.account_numbers != null){
        var { limit = 100, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
        sort = sort||"last_trade_date";
        filter['has_trade'] = 1;
        filter['approved_at'] = {from_date:'2020-01-01'};
        this.columns.forEach(col => {
          if (query[col.field]) {
            filter[col.field] = query[col.field];
          }else if(typeof filter[col.field] != 'undefined'){
            delete filter[col.field];
          }
        });

        let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
        return await this.call_axios(uri);
      }
      this.$toasted.error("Please select atleast one account number.",{duration:1000});
      return {response: {data: {result: []}}}
    },
    async generate_control_report(current=''){
        if(moment(this.report_date[1],'DD-MM-YYYY').diff(moment(this.report_date[0],'DD-MM-YYYY'), 'months') <= 4){
          var default_filename = '';
          if(!this.filename){
            this.current = 'all';
            if(current == 'only'){
              if((['5','6','7', '10', '11', '12'].indexOf(this.sheet)>=0) || (this.account_numbers != null)){
                this.current = this.sheet;
                default_filename = this.options.filter((n,i) => {return n.value==this.sheet;})[0].text.split(" ").join("_").toLowerCase();
              }
              else{
                this.$toasted.error("Please select atleast one account number.",{duration:1000});
                return;
              }
            }

            this.filename = default_filename+'-'+String(this.report_date).replace(',','-');
            this.$refs.get_filename.show();
            return;
          }
          var filename = this.filename;
          this.$refs.get_filename.hide();
          let uri = 'generate_control_report?report_date='+this.report_date+'&filename='+this.filename+'&file_type='+this.filetype;
          if(this.current!='all') uri += '&report='+this.current;
          if(this.account_numbers && this.account_numbers.filter(val => val == 'ALL').length == 0)
            this.filter['account_number']  = this.account_numbers.join(',');
          if(this.filter) uri += '&filter='+JSON.stringify(this.filter);
          await this.call_axios(uri).then(({response}) => {
            if(response.code == 202){
              this.$toasted.success("Please wait, you can download the report once generated.",{duration:2500});
              var checkForNewFile = setInterval(() => {
                  this.call_axios('get_report?file_prefix='+this.filenameprefix+'&filter='+JSON.stringify({filename: filename})).then(files_res => {
                    if(Object.keys(files_res.response.data.result).length){
                      this.$toasted.success("Your report '"+filename+"' has been generated.",{
                          action: {
                            text:'Download',
                            onClick:(e, toast) => {
                              window.open(this.get_baseURL() +'download_report?api_token='+ window.localStorage.getItem('auth_token')+'&filename='+this.filenameprefix+filename+'.'+this.filetype, '_blank');
                              toast.goAway(0);
                            }
                          },
                          duration: null
                      });
                      clearInterval(checkForNewFile)
                    }
                  })
              }, 5000);
            }
          });
        }else{
          this.$toasted.error("Reports can be generated for a maximum of 3 months!",{duration:2000});
        }
    },
    disabledDates(date){
      if(moment(date).isAfter(moment())) return true;
      return false;
    },
    get_report_modal(){
      this.$refs['get-report-out'].show();
    },
    setFilename(name = ''){
      this.filename = '';
    },
    clearAll () {
      this.account_numbers = null
    }
  },
  created() {
    this.getCustomer();
    window.moment = moment;
  },
  mounted () {
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect {
  width: 350px !important;
  min-height: 0px !important;
}
.multiselect__tags {
  height: calc(1.25em + 0.75rem + 2px) !important;
  padding: 0.375rem 2rem 0.375rem 1rem !important;
  min-height: 0px;
}
.multiselect__select {
  height: calc(1.25em + 0.75rem + 2px) !important;
  padding: 0.375rem 2rem 0.375rem 1rem !important;
}
.multiselect--active {
  z-index: 1005;
}
.multiselect__clear {
    position: absolute;
    right: 41px;
    height: 40px;
    width: 40px;
    display: block;
    cursor: pointer;
    z-index: 2;
}
.multiselect__clear::after, .multiselect__clear::before {
    content: "";
    display: block;
    position: absolute;
    width: 3px;
    height: 16px;
    background: #aaa;
    top: 8px;
    right: 4px;
}
.multiselect__clear::before {
    transform: rotate(45deg);
}
.multiselect__clear::after {
    transform: rotate(-45deg);
}
</style>